import React, { FC } from 'react';

type TabPanelProps = {
  index: number;
  value: number;
  hideTabs?: boolean;
};

export const TabPanel: FC<TabPanelProps> = ({ index, value, children, hideTabs }) => {
  return (
    <div
      style={{height: hideTabs ? '100%' : 'unset'}}
      role="tabpanel"
      hidden={value !== index}
      id={`trajectory-sidebar-tabpanel-${index}`}
      aria-labelledby={`trajectory-sidebar-tab-${index}`}
    >
      {value === index && children}
    </div>
  );
};
